export default class ConfiguratorFilters extends HTMLElement {
	#abortController;
	#activeValue;
	#activeLabel;
	#itemsOrigHeadline;

	constructor() {
		super();
		this.form = this.querySelector('form');
		this.inputs = this.form.querySelectorAll('input');
		this.itemsHeadline = document.querySelector('[data-items-headline]');
		this.#itemsOrigHeadline = this.itemsHeadline.textContent.trim();
		this.showBtn = document.querySelector('[data-show-filters-btn]');
		this.observer = document.querySelector('configurator-intersectional-observer');
		this.#onChange({ target: this.form.querySelector('input:checked') });
	}

	connectedCallback() {
		this.#abortController = new AbortController();
		const { signal } = this.#abortController;
		this.form.addEventListener('change', (e) => this.#onChange(e), { signal });
		this.showBtn.addEventListener('click', () => this.dataset.show = 'true');
	}

	disconnectedCallback() {
		this.#abortController.abort();
		this.#abortController = null;
	}

	static get observedAttributes() {
		return ['data-count', 'data-loaded'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		/* console.log(name, newValue); */
		if (name === 'data-count' && newValue !== '') {
			const span = this.querySelector(`label[data-type="${this.#activeLabel}"] span[data-quantity]`);
			span.dataset.quantity = newValue;
		}
		//
		if (name === 'data-loaded' && newValue !== '') {
			const input = this.querySelector(`label[data-type="${this.#activeLabel}"] input`);
			input.dataset.set = 'true';
			this.inputs.forEach(input => input.disabled = false);
		}
	}

	#onChange(e) {
		if (e.target && e.target.value) {
			this.#activeValue = e.target.value;
			this.#activeLabel = e.target.parentElement.dataset.type;
			if (this.#itemsOrigHeadline.length > 0) {
				this.itemsHeadline.textContent = `${this.#itemsOrigHeadline}: ${this.#activeLabel}`;
			} else {
				this.itemsHeadline.textContent = `${this.#activeLabel}`;
			}
			this.observer.dataset.filter = this.#activeValue;
			window.scrollTo({ top: 0, behavior: 'smooth' });
			if (e.target.dataset.set !== 'true') this.inputs.forEach(input => input.disabled = true);
		}
		this.dataset.show = 'false';
	}
}

customElements.define('configurator-filters', ConfiguratorFilters);
